import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { EasyMarineHttpApiLog } from './easy-marine-http-api-log';
import { environment } from 'src/environments/environment';

@Injectable()
export class SlingConfigChangeLogService {

  constructor(private httpClient: EasyMarineHttpApiLog) {
  }

  findByMarinaIdAndDateRange(marinaId: number, startDate: Date, endDate: Date): Observable<any> {
    let params = new HttpParams();
    params = params.append('startDate', startDate.toISOString());
    params = params.append('endDate', endDate.toISOString());

    return this.httpClient.get(
      environment.apiLogV2 + `/secure/sling-config-change-log/marina/${marinaId}/date-range`,
      { params }
    ).pipe(map((response: any) => response));
  }

  findByMarinaId(marinaId: number): Observable<any> {
    return this.httpClient.get(
      environment.apiLogV2 + `/secure/sling-config-change-log/marina/${marinaId}`
    ).pipe(map((response: any) => response));
  }

  findBySlingConfigId(slingConfigId: number): Observable<any> {
    return this.httpClient.get(
      environment.apiLogV2 + `/secure/sling-config-change-log/sling-config/${slingConfigId}`
    ).pipe(map((response: any) => response));
  }
}
